"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.weak-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ol = require("ol");

var _coordinate = require("ol/coordinate");

var _control = require("ol/control");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["map", "style", "className", "coordinateFormatFunc"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Display Text with the current coordinate of the mouse position
 * in the map. If the mouse is outside the map, a empty string 
 * will be shown.
 * 
 * @visibleName CurrentCoordinate Text
 */
var CurrentCoordinateText = function CurrentCoordinateText(_ref) {
  var map = _ref.map,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      _ref$coordinateFormat = _ref.coordinateFormatFunc,
      coordinateFormatFunc = _ref$coordinateFormat === void 0 ? null : _ref$coordinateFormat,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(map.getView()),
      _useState2 = _slicedToArray(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  var ref = (0, _react.useRef)();
  /**
   * Method to return the default coordinate format function.
   * This method will return a function to format the coordinate as:
   * <ul>
   *  <li>x,y with 2 decimal digits: for projected coordinate</li>
   *  <li>y,x with 4 decimal digits: for lat/long</li>
   * </ul>
   * @param {Number} fractionDigits The number of decimal digits for the coordinate
   */

  var getDefaultCoordinateFormatFunc = (0, _react.useCallback)(function () {
    var proj = view.getProjection();
    var axisOrientation = proj.getAxisOrientation();

    var fmtFunc = function fmtFunc(coord) {
      var template = '{x}, {y}'; //invert coordinate for lat/long

      if (axisOrientation === 'neu') {
        template = '{y}, {x}';
        return (0, _coordinate.format)(coord, template, 4);
      } else {
        return (0, _coordinate.format)(coord, template, 2);
      }
    };

    return fmtFunc;
  }, [view]);
  /**
   * Handler to change the state view
   * if a new view is assigned to the map (it 
   * happens if the projection in the map is changed)
   */

  var onChangeViewHandler = (0, _react.useCallback)(function (evt) {
    setView(evt.target.getView());
  }, []);
  /**
   * Register 'change:view' for the map
   * fired if a new view is assigned to the map
   */

  (0, _react.useEffect)(function () {
    map.on('change:view', onChangeViewHandler); //clean-up:

    return function () {
      return map.un('change:view', onChangeViewHandler);
    };
    ;
  }, [map, onChangeViewHandler]);
  (0, _react.useEffect)(function () {
    var mousePositionControl = new _control.MousePosition({
      className: 'custom-mouse-position',
      target: ref.current,
      coordinateFormat: !coordinateFormatFunc ? getDefaultCoordinateFormatFunc() : coordinateFormatFunc,
      undefinedHTML: '&nbsp;'
    });
    map.addControl(mousePositionControl);
    return function () {
      return map.removeControl(mousePositionControl);
    };
  }, [map, coordinateFormatFunc, getDefaultCoordinateFormatFunc]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", _objectSpread({
    ref: ref,
    className: className,
    style: style
  }, otherProps));
};

CurrentCoordinateText.propTypes = {
  /**
   * The OpenLayers ol/Map from where the coordinate will be 
   * retrieved.
   */
  map: _propTypes.default.instanceOf(_ol.Map).isRequired,

  /**
   * A CSS Style to render the Text
   */
  style: _propTypes.default.object,

  /**
   * The CSS class name for this component.
   */
  className: _propTypes.default.string,

  /**
   * A function that takes a ol/coordinate/Coordinate and 
   * transforms it into a string.
   * <p>The default function will format the string in <i>x, y</i>
   * with 2 decimal digits. If the map is in lat-long, the returned
   * string will be <i>y, x</i>.</p>
   */
  coordinateFormatFunc: _propTypes.default.func
};
var _default = CurrentCoordinateText;
exports.default = _default;